import ShopGrid from './ShopGrid';
import ShopGridContainer from './ShopGrid.container';

export default ShopGridContainer(ShopGrid);
